LockedUserController.$inject = ['$scope', '$state'];

// eslint-disable-next-line @treasury/filename-match-export
export default function LockedUserController($scope, $state) {
    $scope.returnToLogin = function () {
        $state.go('login');
    };
}
